import { collectSSRPlaceholderDimensions } from '@atlaskit/react-ufo/ssr-scripts';

import { WATERFALL_INITIAL_MEASURES } from '@confluence/action-measures/entry-points/WaterfallMeasures.ts';
import { fixUnbalancedPlaceholderCommentMarkers } from '@confluence/ssr-scripts-utils/entry-points/fixUnbalancedPlaceholderCommentMarkers.ts';

window?.performance?.mark?.(`${WATERFALL_INITIAL_MEASURES.SSR_AFTER_SCRIPTS}.start`);

// Code in this file runs after HTML body
fixUnbalancedPlaceholderCommentMarkers();

if (window.__SSR_RENDERED__) {
	if (!window.__DELAY_COLLECT_SSR_PLACEHOLDERS__) {
		collectSSRPlaceholderDimensions(document, window);
	}

	require('@confluence/confluence-analytics/ssr-scripts/ssrAnalyticsByLineClickHandler');
	require('@confluence/inline-comments-link-handler/ssr-scripts/ssrInlineCommentsClickHandler');
	require('@confluence/view-page/ssr-scripts/ssrLegacyBridge');
	require('@confluence/title-area-content-components/ssr-scripts/ssrCoverPictureDimension');
}

window?.performance?.mark?.(`${WATERFALL_INITIAL_MEASURES.SSR_AFTER_SCRIPTS}.end`);
